import { render, staticRenderFns } from "./CustomerStockHeader.vue?vue&type=template&id=0786d44a&scoped=true&"
import script from "./CustomerStockHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomerStockHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerStockHeader.vue?vue&type=style&index=0&id=0786d44a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786d44a",
  null
  
)

export default component.exports